export default __webpack_public_path__ + "static/media/Savior's Warhammer.a930220f.jpg";